module.exports = __webpack_public_path__ + "img/demirag-login.988855a4.png";